const inactiveColor = "#979797";
const activeColor = "#4AB932";

export const HomeNavIcon = ({ active = false }) => {
  const stroke = active ? activeColor : inactiveColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      aria-hidden
    >
      <path
        d="M3.16406 12.6406V15.2873C3.16406 18.7663 3.16406 20.5058 4.24485 21.5866C5.32563 22.6674 7.06514 22.6674 10.5441 22.6674H14.7613C18.2403 22.6674 19.9798 22.6674 21.0606 21.5866C22.1414 20.5058 22.1414 18.7663 22.1414 15.2873V12.6406C22.1414 10.868 22.1414 9.9818 21.7662 9.21461C21.391 8.44742 20.6914 7.9033 19.2923 6.81509L17.1837 5.17507C15.0071 3.48218 13.9188 2.63574 12.6527 2.63574C11.3866 2.63574 10.2984 3.48218 8.12181 5.17507L6.01321 6.81509C4.61407 7.9033 3.9145 8.44742 3.53929 9.21461C3.16406 9.9818 3.16406 10.868 3.16406 12.6406Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9219 18.4496V14.2324"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CardsNavIcon = ({ active = false }) => {
  const stroke = active ? activeColor : inactiveColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M19.7695 5.34863H3.52734C2.71186 5.34863 2.05078 6.00971 2.05078 6.82519V17.8994C2.05078 18.7148 2.71186 19.3759 3.52734 19.3759H19.7695C20.5849 19.3759 21.246 18.7148 21.246 17.8994V6.82519C21.246 6.00971 20.5849 5.34863 19.7695 5.34863Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.05078 10.5166H21.246M15.3398 15.6845H17.5546"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CryptoNavIcon = ({ active = false }) => {
  const stroke = active ? activeColor : inactiveColor;
  const fill = active ? activeColor : "none";
  const fillOpacity = active ? 0.16 : 0;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden
    >
      <path
        d="M9.82143 18.8929C14.8314 18.8929 18.8929 14.8314 18.8929 9.82143C18.8929 4.81142 14.8314 0.75 9.82143 0.75C4.81142 0.75 0.75 4.81142 0.75 9.82143C0.75 14.8314 4.81142 18.8929 9.82143 18.8929Z"
        fill={fill}
        fillOpacity={fillOpacity}
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text
        x="10"
        y="13.5"
        textAnchor="middle"
        fontSize="9"
        fontWeight="700"
        fill={stroke}
        fontFamily="system-ui, sans-serif"
      >
        ₿
      </text>
    </svg>
  );
};

export const ManageNavIcon = ({ active = false }) => {
  const stroke = active ? activeColor : inactiveColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M3.88886 9.66294C4.39331 10 5.09554 10 6.5 10C7.90447 10 8.6067 10 9.11115 9.66294C9.32953 9.51702 9.51703 9.32952 9.66294 9.11114C10 8.60669 10 7.90446 10 6.5C10 5.09554 10 4.39331 9.66294 3.88886C9.51703 3.67048 9.32953 3.48298 9.11115 3.33706C8.6067 3 7.90447 3 6.5 3C5.09554 3 4.39331 3 3.88886 3.33706C3.67048 3.48298 3.48298 3.67048 3.33707 3.88886C3 4.39331 3 5.09554 3 6.5C3 7.90446 3 8.60669 3.33707 9.11114C3.48298 9.32952 3.67048 9.51702 3.88886 9.66294Z"
        stroke={stroke}
        strokeWidth="1.42275"
        strokeLinejoin="round"
      />
      <path
        d="M14.8888 9.66294C15.3933 10 16.0955 10 17.5 10C18.9044 10 19.6067 10 20.1111 9.66294C20.3295 9.51702 20.517 9.32952 20.6629 9.11114C21 8.60669 21 7.90446 21 6.5C21 5.09554 21 4.39331 20.6629 3.88886C20.517 3.67048 20.3295 3.48298 20.1111 3.33706C19.6067 3 18.9044 3 17.5 3C16.0955 3 15.3933 3 14.8888 3.33706C14.6705 3.48298 14.483 3.67048 14.337 3.88886C14 4.39331 14 5.09554 14 6.5C14 7.90446 14 8.60669 14.337 9.11114C14.483 9.32952 14.6705 9.51702 14.8888 9.66294Z"
        stroke={stroke}
        strokeWidth="1.42275"
        strokeLinejoin="round"
      />
      <path
        d="M3.88886 20.6629C4.39331 21 5.09554 21 6.5 21C7.90447 21 8.6067 21 9.11115 20.6629C9.32953 20.517 9.51703 20.3295 9.66294 20.1111C10 19.6067 10 18.9045 10 17.5C10 16.0955 10 15.3933 9.66294 14.8889C9.51703 14.6705 9.32953 14.483 9.11115 14.3371C8.6067 14 7.90447 14 6.5 14C5.09554 14 4.39331 14 3.88886 14.3371C3.67048 14.483 3.48298 14.6705 3.33707 14.8889C3 15.3933 3 16.0955 3 17.5C3 18.9045 3 19.6067 3.33707 20.1111C3.48298 20.3295 3.67048 20.517 3.88886 20.6629Z"
        stroke={stroke}
        strokeWidth="1.42275"
        strokeLinejoin="round"
      />
      <path
        d="M14.8888 20.6629C15.3933 21 16.0955 21 17.5 21C18.9044 21 19.6067 21 20.1111 20.6629C20.3295 20.517 20.517 20.3295 20.6629 20.1111C21 19.6067 21 18.9045 21 17.5C21 16.0955 21 15.3933 20.6629 14.8889C20.517 14.6705 20.3295 14.483 20.1111 14.3371C19.6067 14 18.9044 14 17.5 14C16.0955 14 15.3933 14 14.8888 14.3371C14.6705 14.483 14.483 14.6705 14.337 14.8889C14 15.3933 14 16.0955 14 17.5C14 18.9045 14 19.6067 14.337 20.1111C14.483 20.3295 14.6705 20.517 14.8888 20.6629Z"
        stroke={stroke}
        strokeWidth="1.42275"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingIcon = ({ active = false }) => {
  const stroke = active ? activeColor : inactiveColor;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      class="lucide lucide-settings preview-icon"
    >
      <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};
